import { createSignal } from '@verclam/pulsar';

/** The filter applied to every section panel's entries: every field, only those pending review, or
 * only one verification state — objects of primitives, reassigned whole on every write. */
export type VerificationFilter =
	| { readonly type: 'all' }
	| { readonly type: 'pending' }
	| { readonly type: 'status'; readonly value: string };

const ALL_FILTER: VerificationFilter = { type: 'all' };

const verificationFilterSignal = createSignal<VerificationFilter>(ALL_FILTER);

export const setVerificationFilter = (value: VerificationFilter): void => {
	verificationFilterSignal.value = value;
};

export default verificationFilterSignal;
